module.exports = __webpack_public_path__ + "media/images/front/brands/atelier/atelier_header-5ca766488c35f03127d6325331621e58.jpg";